<template>
  <v-container>
    <v-row>
      <v-spacer />
      <v-col  xl="4" lg="6" md="7" sm="8" cols="12">
        <AuthOptions :userType="userType" :redirectRouteName="redirectRouteName" />
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import AuthOptions from '@/components/auth/AuthOptions'

export default {
  name: "StudentLogin",
  components: { AuthOptions },
  computed: {
    userType() {
      return this.$route.params.userType.toUpperCase()
    },
    redirectRouteName() {
      if (this.$route.params.userType == 'student') {
        return 'StudentDashboard'
      }
      else {
        return 'LecturerDashboard'
      }
    }
  }
}
</script>
